import { render, staticRenderFns } from "./TextNotes.vue?vue&type=template&id=4c8e619c&"
import script from "./TextNotes.vue?vue&type=script&lang=js&"
export * from "./TextNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports